declare global {
  interface Window {
    popUpOverlay: PopUpOverlay;
  }
}

class PopUpOverlay {
  private element: HTMLElement | null = document.querySelector('.pop-up-overlay');

  constructor() {
    this.init();
  }

  addEventListeners() {
    if(this.element) {
      this.element.addEventListener('wheel', (e) => this.handleScroll(e));
      this.element.addEventListener('touchmove', (e) => this.handleScroll(e));
    }
  }
    
  handleScroll(e: Event) {
    e.preventDefault();
    e.stopPropagation();
  }

  show() {
    if(this.element) {
      this.element.classList.add('pop-up-overlay--active');
    }
  }

  hide() {
    if(this.element) {
      this.element.classList.remove('pop-up-overlay--active');
    }
  }

  init() {
    this.addEventListeners();
  }
}

export default function popUpOverlay() {
  window.popUpOverlay = new PopUpOverlay();
  new PopUpOverlay();
}